module.exports = __webpack_public_path__ + "img/RazzfazzLogo.e85469c4.png";